import { EventEmitter, Injectable } from '@angular/core';

declare var $: any;

@Injectable()
export class AntennaService {

  constructor() {
    console.log('AntennaService service started')
    this.signalrhub()
    this.initConnection()
    this.startConnection()
  }

  public chat: any
  public readActive: boolean
  public connected: boolean
  public checkPack: Function

  initConnection() {
    console.warn('AntennaService initConnection')

    $.connection.hub.url = localStorage.getItem("impinj-url")// "http://localhost:8899/signalr";
    // Declare a proxy to reference the hub.
    var chat = $.connection.myHub;

    this.chat = chat
    // Create a function that the hub can call to broadcast messages.
    chat.client.addMessage = (message) => {
      this.readActive = true
      if (message === "stopped") {
        console.log("stopped")
        this.connected = false
      } else {
        this.checkPack(JSON.parse(message));
      }
    };
  }
  startConnection() {
    console.log('AntennaService startConnection')
    //let _self = this;
    // Start the connection.
    $.connection.hub.start().done(function () {
      this.readActive;
    });
  }
  stopConnection() {
    console.log('AntennaService stopConnection')

    // this.startAntenna()
    $.connection.hub.stop()
  }

  signalrhub() {
    if (typeof ($.signalR) !== "function") {
      throw new Error("SignalR: SignalR is not loaded. Please ensure jquery.signalR-x.js is referenced before ~/signalr/js.");
    }

    var signalR = $.signalR;

    function makeProxyCallback(hub, callback) {
      return function () {
        // Call the client hub method
        callback.apply(hub, $.makeArray(arguments));
      };
    }

    function registerHubProxies(instance, shouldSubscribe) {
      var key, hub, memberKey, memberValue, subscriptionMethod;

      for (key in instance) {
        if (instance.hasOwnProperty(key)) {
          hub = instance[key];

          if (!(hub.hubName)) {
            // Not a client hub
            continue;
          }

          if (shouldSubscribe) {
            // We want to subscribe to the hub events
            subscriptionMethod = hub.on;
          } else {
            // We want to unsubscribe from the hub events
            subscriptionMethod = hub.off;
          }

          // Loop through all members on the hub and find client hub functions to subscribe/unsubscribe
          for (memberKey in hub.client) {
            if (hub.client.hasOwnProperty(memberKey)) {
              memberValue = hub.client[memberKey];

              if (!$.isFunction(memberValue)) {
                // Not a client hub function
                continue;
              }

              // Use the actual user-provided callback as the "identity" value for the registration.
              subscriptionMethod.call(hub, memberKey, makeProxyCallback(hub, memberValue), memberValue);
            }
          }
        }
      }
    }

    $.hubConnection.prototype.createHubProxies = function () {
      var proxies = {};
      this.starting(function () {
        // Register the hub proxies as subscribed
        // (instance, shouldSubscribe)
        registerHubProxies(proxies, true);

        this._registerSubscribedHubs();
      }).disconnected(function () {
        // Unsubscribe all hub proxies when we "disconnect".  This is to ensure that we do not re-add functional call backs.
        // (instance, shouldSubscribe)
        registerHubProxies(proxies, false);
      });

      proxies['myHub'] = this.createHubProxy('myHub');
      proxies['myHub'].client = {};
      proxies['myHub'].server = {
        recieve: function (param) {
          return proxies['myHub'].invoke.apply(proxies['myHub'], $.merge(["Recieve"], $.makeArray(arguments)));
        },

        send: function (message) {
          return proxies['myHub'].invoke.apply(proxies['myHub'], $.merge(["Send"], $.makeArray(arguments)));
        }
      };

      return proxies;
    };

    signalR.hub = $.hubConnection("/signalr", { useDefaultPath: false });
    $.extend(signalR, signalR.hub.createHubProxies());
  }
}



// WEBPACK FOOTER //
// ./src/app/+common/services/antenna.service.ts